export default "__VITE_ASSET__BJ7EM7pH__"